<div class="login-container">
  <div class="login-content">
    <img src="../../../assets/images/afs-logo.png" alt="Logo" class="login-logo" />
    <p class="login-textmain">Login your account.</p>
    <p class="login-textsub">Enter your new password details below to access your account.</p>
    <form class="new-form top-margin-30" (ngSubmit)="onSubmit()">

      <div class="form-group">
        <mat-form-field style="width:100%;" appearance="outline">
          <mat-label>Enter New password</mat-label>
          <input matInput [type]="hide ? 'password' : 'text'" type="password" name="password"
            [(ngModel)]="LoginData.password">
          <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hide">
            <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <div class="form-group">
        <mat-form-field style="width:100%" appearance="outline">
          <mat-label>Enter Confirm Password</mat-label>
          <input matInput [type]="hide ? 'password' : 'text'" type="password" name="confirmpassword"
            [(ngModel)]="confirmpassword">
          <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hide">
            <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <button mat-raised-button class="login-btn" type="submit">Reset Password 
        <i class="fa fa-long-arrow-right left-margin-10"> </i></button>
      <div class="clearfix"></div>
    </form>
  </div>
  <div class="copyright-login"> © 2022 AFS Group. All rights reserved.</div>
</div>